import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

//定義 state，所有狀態值存取
const state = {
    name: '謝謝惠顧',
    contle: '會盡快處理您的訂單',
    age: 29289
}

//定義 mutations，可以傳參，用於更改 state的值
const mutations = {
    set_name:(state,val) => {
        state.name = val.til
        state.contle = val.cont
    },
    set_age:(state,val) => {
        state.age = val
    },
}

//定義 getters，用於獲取 state值再做加工  //＊＊＊暫時不知道這是做啥的＊＊＊＊
const getters = {
    get_age:state =>{
        return state.age.toLocaleString()
    }
}

//導出
export default new Vuex.Store({
    state,
    mutations,
    getters
})

